import { render, staticRenderFns } from "./ManageAccessUserProfileModal.vue?vue&type=template&id=582e7da0&lang=pug"
import script from "./ManageAccessUserProfileModal.vue?vue&type=script&lang=js"
export * from "./ManageAccessUserProfileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports